export default [
  'ADD_ADVANCED_FILTERS',
  'ADD_TEMPLATE_TO_WORKING_STATE',
  'ADD_DESIGN_OPTION_FILTER',
  'ADD_TEMPLATES_TO_CART_REQUEST',
  'CLEAR_ADVANCED_FILTERS',
  'CLEAR_MODEL_COMPETITION_DATA',
  'CLEAR_DESIGN_OPTION_FILTERS',
  'CLEAR_ALL_DESIGN_OPTION_FILTERS',
  'CLEAR_ALL_LOCAL_FILTERS',
  'CLOSE_ANNOUNCEMENTS',
  'CREATE_AUTHENTICATION_REQUEST',
  'DELETE_ADVANCED_FILTERS',
  'DELETE_AUTHENTICATION',
  'FETCH_USER_SETTING_REQUEST',
  'GET_ADDITIONAL_CART_REQUEST',
  'GET_ANNOUNCEMENTS_REQUEST',
  'GET_CART_REQUEST',
  'GET_DASHBOARD_REQUEST',
  'GET_DEALERSHIP_ALLOCATION_REQUEST',
  'GET_MODEL_ADVANCED_REQUEST',
  'GET_MODEL_ADVANCED_WITH_FILTERS_REQUEST',
  'GET_MODEL_COMPETITION_REQUEST',
  'GET_MODEL_PIPELINE_REQUEST',
  'GET_MODEL_TEMPLATES_REQUEST',
  'GET_MODEL_TEMPLATES_SPECS_REQUEST',
  'GET_MODEL_TEMPLATES_WORKING_STATE_REQUEST',
  'GET_MODELS_VIEWERS_REQUEST',
  'GET_SERIES_PIPELINE_REQUEST',
  'GET_TEMPLATE_DETAIL_IMAGES_REQUEST',
  'GET_TOTAL_CART_QUANTITY_REQUEST',
  'HIDE_CART_UPDATE_MESSAGE',
  'REMOVE_TEMPLATE_FROM_WORKING_STATE',
  'REMOVE_DESIGN_OPTION_FILTER',
  'RESET_CHECK_ACTIVITY_INTERVAL',
  'RESET_CHECK_LOCK_STATUS',
  'RESET_MODEL_LOCK_EXPIRED',
  'SELECT_ALL_TEMPLATES_CART_BODY_STYLE',
  'SELECT_TEMPLATE_IN_CART',
  'SET_ACTIVE_VIEWERSHIP',
  'SET_CHECK_ACTIVITY_INTERVAL',
  'SET_DUPLICATE_TEMPLATE_ID',
  'SET_INACTIVE_VIEWERSHIP',
  'SET_MODEL_IS_ACTIVE',
  'SET_MODEL_IS_NOT_ACTIVE',
  'SET_MODEL_LOCK_EXPIRED',
  'SET_SELECTED_OPTIONS',
  'SET_SELECTED_SERIES_ID',
  'SET_SELECTED_TEMPLATE_ID',
  'SET_SWAPPED_TEMPLATE_ID',
  'SHOW_CART_UPDATE_MESSAGE',
  'SUBMIT_CART_TEMPLATES_REQUEST',
  'SWAP_TEMPLATES',
  'TOGGLE_USER_SETTING',
  'UNSELECT_TEMPLATE_IN_CART',
  'UPDATE_CURRENT_VIEWER_REQUEST',
  'UPDATE_IN_REVIEW_TEMPLATE_PRIORITY',
  'UPDATE_PRIORITY_QUANTITY',
  'UPDATE_SELECTED_CHART',
  'UPDATE_USER_SETTING_REQUEST',
  'WEBSOCKET_CLOSE',
  'WEBSOCKET_CONNECT',
  'WEBSOCKET_DISCONNECT',
  'WEBSOCKET_OPEN',
  'WEBSOCKET_SEND',
  'WEBSOCKET_UPDATE_CURRENT_USER',
].reduce((types, type) => {
  if (type.endsWith('REQUEST')) {
    const failureType = `${type}_FAILURE`;
    const successType = `${type}_SUCCESS`;
    return {
      ...types,
      [type]: type,
      [failureType]: failureType,
      [successType]: successType,
    };
  }

  return { ...types, [type]: type };
}, {});
